import { Link } from "react-router-dom";
import { Reveal } from "@/components/common/Reveal";
import { ArrowRight } from "lucide-react";

export const Methode = () => (
    <section
        data-testid="methode-section"
        className="relative bg-rz-green text-white py-24 lg:py-32 overflow-hidden"
    >
        <div className="mx-auto max-w-[1400px] px-6 md:px-12">
            <div className="grid gap-12 lg:grid-cols-12 lg:gap-16 items-start">
                <div className="lg:col-span-6">
                    <Reveal>
                        <span className="text-xs tracking-[0.22em] uppercase text-rz-sage font-semibold">
                            La Méthode Rozier®
                        </span>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="font-display mt-6 text-[clamp(2.2rem,5vw,4rem)] font-extrabold tracking-tight leading-[1.02]">
                            Comprendre <br className="hidden sm:block" />
                            <span className="text-rz-pale">avant de concevoir.</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.18}>
                        <span className="mt-8 block h-px w-20 bg-rz-sage/50" />
                    </Reveal>
                </div>

                <div className="lg:col-span-6 lg:pt-2">
                    <Reveal delay={0.2}>
                        <p className="text-lg leading-relaxed text-white/80">
                            Une exploitation agricole, un haras ou un domaine équestre est un
                            écosystème complexe où interagissent les hommes, les animaux, les
                            bâtiments, les paysages, l'eau, l'énergie et l'économie de
                            l'exploitation.
                        </p>
                        <p className="mt-5 text-lg leading-relaxed text-white/80">
                            La Méthode Rozier associe les compétences de l'architecture, de
                            l'agriculture, du paysage, de l'énergie et de l'analyse du lieu afin
                            de concevoir des projets cohérents, durables et performants.
                        </p>
                    </Reveal>
                </div>
            </div>

            <div className="mt-16 lg:mt-20 grid gap-10 lg:grid-cols-12 items-center border-t border-white/10 pt-12">
                <div className="lg:col-span-8">
                    <Reveal>
                        <p className="text-base lg:text-lg leading-relaxed text-white/70 max-w-3xl">
                            Avant de dessiner le moindre bâtiment, nous cherchons à comprendre votre
                            activité, vos ambitions, le fonctionnement du site, les flux humains et
                            animaux, les contraintes techniques et les opportunités futures. Cette
                            phase de compréhension est la base de tout projet durable.
                        </p>
                    </Reveal>
                </div>
                <div className="lg:col-span-4 lg:text-right">
                    <Reveal delay={0.15}>
                        <Link
                            to="/methode"
                            data-testid="methode-cta"
                            className="group inline-flex items-center gap-2 rounded-full border border-white/25 px-7 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-white hover:text-rz-green"
                        >
                            Découvrir la méthode
                            <ArrowRight
                                size={17}
                                className="transition-transform duration-300 group-hover:translate-x-1"
                            />
                        </Link>
                    </Reveal>
                </div>
            </div>
        </div>
    </section>
);
